import './Steps.css';
import { Steps as StepsAntd } from 'antd';

const Steps = ({ current, setCurrent, stepsItem, maxReached = 0 }) => {
  const items = stepsItem.map((s, idx) => ({
    ...s,
    disabled: idx > maxReached,
  }));

  return (
    <div className="steps-container">
      <StepsAntd
        className="steps"
        orientation="vertical"
        current={current}
        items={items}
        onChange={(next) => {
          if (next > maxReached) return;
          setCurrent(next);
        }}
      />
    </div>
  );
};

export default Steps;